'use client'

import {useEffect} from 'react';
import {getAppInsights} from '@/lib/appInsights';

export default function GlobalError({
                                        error,
                                        reset,
                                    }: {
    error: Error & { digest?: string }
    reset: () => void
}) {
    useEffect(() => {
        const appInsights = getAppInsights();
        if (appInsights) {
            appInsights.trackException({
                exception: error,
                severityLevel: 3,
                properties: {
                    digest: error.digest,
                    type: 'global-error-boundary'
                }
            });
        }
    }, [error]);

    return (
        <html lang="en">
        <body className="bg-[#F0F0F0] text-black min-h-screen flex flex-col items-center justify-center p-4">
            <div className="max-w-md w-full text-center space-y-4">
                <h2 className="text-2xl font-bold">Something went wrong!</h2>
                <p className="text-gray-600">An unexpected error occurred. Please try again.</p>
                <button
                    onClick={() => reset()}
                    className="bg-black text-white px-6 py-3 rounded-lg hover:bg-gray-800 transition-colors"
                >
                    Try again
                </button>
            </div>
        </body>
        </html>
    )
}
